const APP_PASSWORD_KEY = "app-password";

export function getAppPassword(): string | null {
  try {
    return localStorage.getItem(APP_PASSWORD_KEY);
  } catch {
    return null;
  }
}

export function setAppPassword(pw: string): void {
  try {
    localStorage.setItem(APP_PASSWORD_KEY, pw);
  } catch {}
}

export function clearAppPassword(): void {
  try {
    localStorage.removeItem(APP_PASSWORD_KEY);
  } catch {}
}

const PROD_BACKEND_URL = "https://lm.leobite.nl";

declare const process: { env: { BACKEND_URL?: string } } | undefined;
const RAW_URL = (typeof process !== "undefined" ? process.env.BACKEND_URL : "") || "";

function resolveBackendUrl(): string {
  if (RAW_URL) return RAW_URL.replace(/\/$/, "");
  if (typeof window !== "undefined") {
    const proto = window.location.protocol;
    if (proto !== "http:" && proto !== "https:") return PROD_BACKEND_URL;
  }
  return "";
}

export const BACKEND_URL = resolveBackendUrl();

export function apiUrl(path: string): string {
  return BACKEND_URL ? `${BACKEND_URL}${path}` : path;
}

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  const pw = getAppPassword();
  if (pw) headers.set("X-App-Password", pw);
  return fetch(apiUrl(path), { ...init, headers });
}
